"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 w-full">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="space-y-4">
            <div className="h-5 w-24 bg-muted-foreground/20 rounded-md animate-pulse" />
            <div className="space-y-2">
              <div className="h-4 w-16 bg-muted-foreground/10 rounded-md animate-pulse" />
              <div className="h-4 w-20 bg-muted-foreground/10 rounded-md animate-pulse" />
            </div>
          </div>)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  const hasChildren = menuItems.some(item => item.children && item.children.length > 0);
  if (hasChildren) {
    return <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 w-full">
        {menuItems.map((col, i) => <div key={col.id} data-index={i} className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground text-lg">
              {col.label}
            </h3>
            {col.children && col.children.length > 0 && <ul className="flex flex-col gap-2.5">
                {col.children.map((link, j) => <li key={link.id} data-index={j}>
                    <Link to={link.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>}
          </div>)}
      </div>;
  }
  return <ul className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full">
      {menuItems.map((link, i) => <li key={link.id} data-index={i}>
          <Link to={link.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {link.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const footerLinks = [{
    label: "View Our Menu",
    path: "/OurMenuPage"
  }, {
    label: "Visit Our Location",
    path: "https://maps.app.goo.gl/JFtR4MUzV8npu7H59"
  }, {
    label: "Instagram",
    path: "https://www.instagram.com/frozen_paradise_by_ksanti?igsh=MTVjNDE0dXU0a3hrin"
  }];
  return <section data-section-id="260040" id="footer" className="dark bg-background text-foreground border-t border-border/20 pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          
          <div className="lg:col-span-3 flex flex-col items-start gap-4">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm font-default mt-2 max-w-xs leading-relaxed">
              Frozen Paradise by Ksanti, V2F5+GX4, Sarandë, Albania | Phone: <Link to="tel:+355696863772" className="hover:text-primary transition-colors">+355 69 686 3772</Link>
            </p>
          </div>

          <div className="lg:col-span-6 flex justify-center">
            <MenuProvider menu_id="17" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="lg:col-span-3 flex flex-col items-start lg:items-end justify-start gap-6">
            <div className="flex flex-col items-start lg:items-end gap-4">
              <h3 className="font-default font-semibold text-foreground text-lg">Quick Links</h3>
              <ul className="flex flex-col items-start lg:items-end gap-2.5">
                {footerLinks.map((link, i) => <li key={i} data-index={i}>
                    <Link to={link.path} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>
            <Button variant="outline" className="border-primary/30 text-foreground hover:bg-primary hover:text-primary-foreground transition-colors bg-transparent rounded-md" asChild>
              <Link to="#">View Our Menu</Link>
            </Button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p className="font-default text-[10px] text-muted-foreground/60">
            Made with love in Saranda. © {new Date().getFullYear()} Frozen Paradise.
          </p>
          <p className="font-mono text-[10px] tracking-widest uppercase opacity-50">Est. 2024</p>
        </div>
      </div>
    </section>;
}